import { ExternalFilters } from '../types/ExternalFilters';
import { Filters } from '../types/Filters';

/**
 * Converts flat external filter format into the internal store format.
 *
 * This is the inverse of `unwrapFilterValues`.
 *
 * ## Format mapping
 *
 * Flat (ExternalFilters):  `{ columnKey: actualValue }`
 * Store (Filters):         `{ columnKey: { value: actualValue } }`
 *
 * Every EagGrid filter widget stores its value wrapped in `{ value: X }` —
 * this wrapper is the internal representation used by `FilterState`.
 * External filter components however work with the flat `ExternalFilters`
 * format (same contract as `FormToDataGridConnectorProps.values`).
 *
 * @param values - Flat filter values from an external filter component.
 * @returns Wrapped filter state ready to be stored via `store.setFilterValues`.
 */
export const wrapFilterValues = (values: ExternalFilters): Filters => Object.fromEntries(Object.entries(values).map(([key, value]) => [key, {
  value
}]));